export const PROJECT_FIELD_CONFIG = [
    // Inspiration Elements -> Overview (sidebar) / Overview & Strategy (detail page)
    {
        field: 'insightElements',
        label: 'Insight/Opportunity',
        overviewCategory: 'overview',
        detailCategory: 'overviewStrategy'
    },
    {
        field: 'consumerElements',
        label: 'Consumer',
        overviewCategory: 'overview',
        detailCategory: 'overviewStrategy'
    },
    {
        field: 'benefitElements',
        label: 'Product Benefits',
        overviewCategory: 'overview',
        detailCategory: 'overviewStrategy'
    },
    {
        field: 'strategicIntent',
        label: 'Strategic Intent',
        overviewCategory: null,
        detailCategory: 'overviewStrategy'
    },
    {
        field: 'referenceProjects',
        label: 'Reference Projects',
        overviewCategory: null,
        detailCategory: 'overviewStrategy'
    },
    {
        field: 'creationTeam',
        label: 'Creation Team',
        overviewCategory: null,
        detailCategory: 'overviewStrategy'
    },
    {
        field: 'creationTrack',
        label: 'Creation Track',
        overviewCategory: null,
        detailCategory: 'overviewStrategy'
    },
    {
        field: 'intendedLaunch',
        label: 'Intro Date',
        overviewCategory: null,
        detailCategory: 'overviewStrategy'
    },
    {
        field: 'intendedLifecycle',
        label: 'Lifecycle',
        overviewCategory: null,
        detailCategory: 'overviewStrategy'
    },
    {
        field: 'season',
        label: 'Season',
        overviewCategory: null,
        detailCategory: 'overviewStrategy'
    },
    {
        field: 'projectedUnit',
        label: 'Est. Volume',
        overviewCategory: null,
        detailCategory: 'overviewStrategy'
    },
    // Team-related -> Teams (sidebar) / Team & Planning (detail page)
    {
        field: 'teams',
        label: 'Project Team',
        overviewCategory: 'teams',
        detailCategory: 'teamPlanning'
    },
    {
        field: 'criticalDateTimeline',
        label: 'Critical Date Timeline',
        overviewCategory: 'teams',
        detailCategory: 'teamPlanning'
    },
    {
        field: 'unansweredQuestions',
        label: 'Unanswered Questions',
        overviewCategory: 'teams',
        detailCategory: 'teamPlanning'
    },
    // Nuts & Bolts -> Details (sidebar) / Product Definition (detail page)
    {
        field: 'msrp',
        label: 'Retail',
        overviewCategory: 'details',
        detailCategory: 'productDefinition'
    },
    {
        field: 'fob',
        label: 'Wholesale',
        overviewCategory: 'details',
        detailCategory: 'productDefinition'
    },
    {
        field: 'margin',
        label: 'Margin',
        overviewCategory: 'details',
        detailCategory: 'productDefinition'
    },
    {
        field: 'targetGeo',
        label: 'Target Geo',
        overviewCategory: 'details',
        detailCategory: 'productDefinition'
    },
    {
        field: 'production',
        label: 'Production',
        overviewCategory: 'details',
        detailCategory: 'productDefinition'
    },
    {
        field: 'factory',
        label: 'Factory',
        overviewCategory: 'details',
        detailCategory: 'productDefinition'
    },
    {
        field: 'testingSizes',
        label: 'Testing Size(s)',
        overviewCategory: 'details',
        detailCategory: 'productDefinition'
    },
    {
        field: 'sampleLast',
        label: 'Sample Last',
        overviewCategory: 'details',
        detailCategory: 'productDefinition'
    },
    {
        field: 'tdCode',
        label: 'TD Code',
        overviewCategory: 'details',
        detailCategory: 'productDefinition'
    },
    {
        field: 'toolingBudget',
        label: 'Tooling Budget',
        overviewCategory: 'details',
        detailCategory: 'productDefinition'
    },
    {
        field: 'dutyDriver',
        label: 'Duty Driver',
        overviewCategory: 'details',
        detailCategory: 'productDefinition'
    },
    {
        field: 'buildValue',
        label: 'Build Value',
        overviewCategory: 'details',
        detailCategory: 'productDefinition'
    },
    // Design & Materials -> Details (sidebar) / Design & Materials (detail page)
    {
        field: 'keyToolingBottom',
        label: 'Key Tooling',
        overviewCategory: 'details',
        detailCategory: 'designMaterials'
    },
    {
        field: 'keyUpper',
        label: 'Key Upper',
        overviewCategory: 'details',
        detailCategory: 'designMaterials'
    },
    {
        field: 'materialAndMins',
        label: 'Material & Mins',
        overviewCategory: 'details',
        detailCategory: 'designMaterials'
    },
    {
        field: 'sustainabilityIntent',
        label: 'Sustainability',
        overviewCategory: 'details',
        detailCategory: 'designMaterials'
    },
    {
        field: 'technologies',
        label: 'Technologies',
        overviewCategory: 'details',
        detailCategory: 'designMaterials'
    },
    {
        field: 'newTool',
        label: 'New Tool And/Or',
        overviewCategory: 'details',
        detailCategory: 'designMaterials'
    }
];
export function getFieldsByOverviewCategory(category) {
    return PROJECT_FIELD_CONFIG.filter((f) => f.overviewCategory === category);
}
export function getFieldsByDetailCategory(category) {
    return PROJECT_FIELD_CONFIG.filter((f) => f.detailCategory === category);
}
export function getFieldLabel(field) {
    const config = PROJECT_FIELD_CONFIG.find((f) => f.field === field);
    return config?.label || field;
}
